<template>
  <div class="relative my-4 lg:my-8 ">
    <div ref="rootEl" class="bosnia-delegation-carousel swiper-container custom-overflow" manual-init>
      <div class="swiper-wrapper">
        <slot />
      </div>

    </div>
    <div class="swiper-button-prev swiper-nav-btn mt-0 js-swiper-prev w-12 h-12 left-arrow">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M8 0L9.41 1.41L3.83 7H16V9H3.83L9.41 14.59L8 16L0 8L8 0Z" fill="white"/>
        </svg>
      </div>
      <div class="swiper-button-next swiper-nav-btn mt-0 js-swiper-next h-12 w-12 right-arrow " >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z" fill="white"/>
        </svg>
      </div>
  </div>
</template>

<script>
import Swiper from 'swiper';

const DEFAULT_CONFIG = {
  watchOverflow: true,
  autoplay: true,
  simulateTouch: true,
  slidesPerView: 'auto',
  spaceBetween: 32,
  slidesPerView: 1
};


export default {
  mounted() {
    this.swiper = new Swiper(this.$refs.rootEl, {
      ...DEFAULT_CONFIG,
      navigation: {
        nextEl: this.$el.querySelector('.js-swiper-next'),
        prevEl: this.$el.querySelector('.js-swiper-prev')
      },
      breakpoints: this.breakpoints,
      ...this.config
    });
  }
};
</script>

<style lang="scss" scoped>
.left-arrow {
  background: rgba(8, 40, 79, 0.5)!important;
}

.right-arrow  {
  background: rgba(8, 40, 79, 0.5)!important;
}
.swiper-nav-btn {
  top: 40%;
}

</style>
